export default "__VITE_ASSET__D87s6u6H__"